<template>
  <section class="block block-cards">
    <div class="container">
      <PageHierarchySection
        v-if="stories.length"
        :filtered-audiences="filteredAudiences"
        :filtered-topics="filteredTopics"
        :section="contentType"
        :show-more="showMore"
        :subheading="subheading"
        :title="title"
      >
        <div class="row flex-wrap">
          <component
            :is="contentType + 'List'"
            :blok="stories"
            :content-type="contentType"
            :is-filtered="shouldShowBasicList"
            :use-featured-card="shouldUseFeatureCard"
          />
        </div>
      </PageHierarchySection>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { ISbStoryData } from 'storyblok'

const props = withDefaults(
  defineProps<{
    stories: ISbStoryData[]
    title?: string
    subheading?: string
    contentType?: string
    filteredTopics?: string[]
    filteredAudiences?: string[]
    showMore?: boolean
    expectedResults?: number
  }>(),
  {
    title: '',
    subheading: '',
    contentType: 'featured-topics',
    filteredTopics: () => [],
    filteredAudiences: () => [],
    showMore: true,
    expectedResults: 3,
  },
)

const shouldShowBasicList = computed(
  () =>
    props.stories.length !== props.expectedResults &&
    props.contentType === 'featured-topics',
)

const shouldUseFeatureCard = computed(
  () => props.contentType === 'featured-topics' && !shouldShowBasicList.value,
)
</script>
